import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-emi-calculator',
  templateUrl: './emi-calculator.component.html',
  styleUrls: ['./emi-calculator.component.scss']
})
export class EmiCalculatorComponent implements OnInit{


  isSFLoan:boolean = false;
  formator = new Intl.NumberFormat('en-IN',);
  amount: number = 5000;
  interest: number = 14;
  tenure: number = 3;
  monthlyEMI:number = 5000;


  constructor(private util: UtilService) { }

  ngOnInit(): void {
    this.isSFLoan = this.util.loanDetails.productCategory === "EL_SF" || false;
    this.interest = this.isSFLoan ? 7.7 : 14;
  }


   get isValidValue(){
    return this.amount<5000 || this.interest<14 || this.tenure<3 || this.amount>1500000 || this.interest>16 || this.tenure>36;
  }
  isAmountValid(){
    return this.isSFLoan ? this.amount<=1500000 && this.amount>=5000 : this.amount<=500000 && this.amount>=5000;
  }

  isTenureValid(){
    return this.isSFLoan ? this.tenure<=12 && this.tenure>=3 : this.tenure<=36 && this.tenure>=2;
  }
  isInterestValid(){
    return this.isSFLoan ? this.interest<=8.90 && this.interest>=7.70 : this.interest<=16.00 && this.interest>=14.00;
    
  }


 get calculateEMI(){
  if(this.isValidValue){
    return '--';
  }
    this. monthlyEMI = this.util.monthlyEMI(this.interest, this.tenure, this.amount);
   return this.formator.format(this.monthlyEMI);
   
  }

  customValidator(control:any) {
    const value = control.value;
    if (value < 1) {
      return { lessThanOne: true };
    }
    return null;
  }

  goTohome() {
    this.util.route('home');
  }





}
